<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M7 12L13.209 18.2807C13.6004 18.6766 14.2398 18.6766 14.6312 18.2807L15.3048 17.5995C15.69 17.2099 15.69 16.5828 15.3047 16.1933L11.1579 12L15.3047 7.80676C15.69 7.41719 15.69 6.79014 15.3048 6.40052L14.6312 5.71928C14.2398 5.32337 13.6004 5.32339 13.209 5.71933L7 12Z"
      class="fill-current"
    />
  </svg>
</template>
